module.exports = __webpack_public_path__ + "static/media/prime-article.1d6f42af.jpeg";